import Vue from 'vue'
export default () => {
  const state = Vue.observable({
    error: {},
    params: {
      deleteFolder: false,
      id: '',
      isUpdate: false,
      blocking: '',
      hasBlocking: false,
      ephemeral: false,
      name: '',
      signature: false,
      visible: true
    },
    pagination: {
      currentPage: 1,
      perPage: 10
    },
    subFolderParams: {
      docSinId: false,
      deleteFolder: false,
      id: '',
      isUpdate: false,
      isDigitalDocument: false,
      isLoadDocument: false,
      documentType: 'pdf',
      emailName: '',
      emailNameOverride: false,
      folderId: '',
      name: '',
      parser: 'rcb_parser',
      templateId: '',
      visible: false,
      previewConfiguration: {},
      documentConfiguration: {
        appliedConfig: [],
        crop: '',
        rotation: 0,
        orientation: '',
        paper: '',
        file: '',
        fileBase64: null,
        employeeSignature: {
          position: 'CB',
          paper: 'A4',
          orientation: '',
          x: -160,
          y: -160,
          page: 1,
          show: false,
          default: true
        },
        employerSignature: '',
        rotationApplied: false,
        croppedApplied: false
      },
      isGenericDocument: false,
      isAiDocument: false,
      isSalaryReceipt: false
    },
    companyLogo: ''
  })
  const setParams = (newParams) => {
    state.params = Object.assign({}, state.params, newParams)
  }

  const setPreviewConfiguration = (previewConfiguration) => {
    state.subFolderParams.previewConfiguration = Object.assign(
      {},
      state.subFolderParams.previewConfiguration,
      previewConfiguration
    )
  }
  const setSubFolderParams = (newParams) => {
    state.subFolderParams = Object.assign({}, state.subFolderParams, newParams)
  }
  const setSubFolderSignatureParams = (newParams) => {
    state.subFolderParams.position_signature = Object.assign(
      {},
      state.subFolderParams.position_signature,
      newParams
    )
  }
  const setPagination = (pag) => {
    state.pagination = Object.assign({}, state.pagination, pag)
  }
  const setError = (errors) => {
    state.error = Object.assign({}, state.error, errors)
  }
  const setCompanyLogo = (base64) => {
    state.companyLogo = base64
  }
  const setDocumentConfiguration = (newParams) => {
    state.subFolderParams.documentConfiguration = Object.assign(
      {},
      state.subFolderParams.documentConfiguration,
      newParams
    )
  }
  const setSignatureEmployer = (newParams, clear = false) => {
    if (clear) {
      state.subFolderParams.documentConfiguration.employerSignature = {}
      return
    }
    state.subFolderParams.documentConfiguration.employerSignature =
      Object.assign(
        {},
        state.subFolderParams.documentConfiguration.employerSignature,
        newParams
      )
  }
  const setSignatureEmployee = (newParams) => {
    state.subFolderParams.documentConfiguration.employeeSignature =
      Object.assign(
        {},
        state.subFolderParams.documentConfiguration.employeeSignature,
        newParams
      )
  }
  const setSignatureDefault = (bool) => {
    state.subFolderParams.documentConfiguration.employeeSignature.default = bool
  }
  const resetPreviewConfiguration = () => {
    state.subFolderParams.previewConfiguration = {}
  }
  const resetParams = () => {
    state.error = {}
    state.params = {
      deleteFolder: false,
      id: '',
      isUpdate: false,
      blocking: '',
      hasBlocking: false,
      ephemeral: false,
      name: '',
      signature: false,
      visible: true
    }
  }
  const resetSubFolderParams = () => {
    state.error = {}
    state.subFolderParams = {
      docSinId: false,
      deleteFolder: false,
      id: '',
      isUpdate: false,
      isDigitalDocument: false,
      documentType: 'pdf',
      emailName: '',
      emailNameOverride: false,
      folderId: '',
      name: '',
      parser: 'rcb_parser',
      templateId: '',
      isLoadDocument: false,
      visible: false,
      previewConfiguration: {},
      documentConfiguration: {
        appliedConfig: [],
        crop: '',
        rotation: 0,
        orientation: '',
        paper: '',
        file: '',
        fileBase64: null,
        employeeSignature: {
          position: 'CB',
          paper: 'A4',
          orientation: '',
          x: -160,
          y: -160,
          page: 1,
          show: false,
          default: true
        },
        employerSignature: '',
        rotationApplied: false,
        croppedApplied: false
      },
      isGenericDocument: false,
      isAiDocument: false,
      isSalaryReceipt: false
    }
  }
  const resetError = () => {
    state.error = {}
  }
  const resetDocumentConfiguration = () => {
    state.subFolderParams.documentConfiguration = {
      appliedConfig: [],
      crop: '',
      rotation: 0,
      orientation: '',
      paper: '',
      file: '',
      fileBase64: null,
      employeeSignature: {
        position: 'CB',
        paper: 'A4',
        orientation: '',
        x: -160,
        y: -160,
        page: 1,
        show: false,
        default: true
      },
      employerSignature: '',
      rotationApplied: false,
      croppedApplied: false
    }
  }
  return {
    state,
    resetParams,
    resetSubFolderParams,
    setParams,
    setPagination,
    setError,
    setCompanyLogo,
    resetError,
    setSubFolderParams,
    setSubFolderSignatureParams,
    setPreviewConfiguration,
    setDocumentConfiguration,
    setSignatureEmployer,
    setSignatureEmployee,
    setSignatureDefault,
    resetPreviewConfiguration,
    resetDocumentConfiguration
  }
}
